const standard = (base, module) =>
  ['START', 'FINISH', 'ERROR'].map(x => `${base}_${x}`)
    .reduce((obj, x) => ({...obj, [x]: `${module}${x}`}), {});

const actions = {
  auth: {
    ...standard('LOGON'),
    ...standard('LOGOFF'),
  },
  organizations: {
    ...standard('SELECT'),
  },
  games: {
    ...standard('ENTER'),
    ...standard('LEAVE'),
    current: {
      CATEGORIES_UPDATED: 'CATEGORIES_UPDATED',
      DETAILS_UPDATED: 'DETAILS_UPDATED',
      PLAYERS_UPDATED: 'PLAYERS_UPDATED',
      PLAYERS_SELCTABLE_UPDATED: 'PLAYERS_SELCTABLE_UPDATED',
      RATING_ADDED: 'RATING_ADDED',
    }
  },
  entities: {
    categories: {
      ...standard('DELETE'),
    },
    games: {
      ...standard('CREATE'),
      ...standard('DELETE'),
    },
    organizations: {
      ...standard('GET'),
    },
    players: {
      ...standard('CREATE'),
      ...standard('DELETE'),
      ...standard('UPDATE'),
    },
    teams: {
      ...standard('DELETE'),
    },
  }
};

const constants = {
  actions,
};

export { actions, standard };
export default constants;



// WEBPACK FOOTER //
// ./src/constants.js